module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-Regular-7320e5ff2faeb26baafa8381aa0f5671.svg";